/* tslint:disable */
/* eslint-disable */
/**
 * DAM PORTAL API
 * API for handling DAM PORTAL operations.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApplicationError,
    ApplicationErrorFromJSON,
    ApplicationErrorToJSON,
    Asset,
    AssetFromJSON,
    AssetToJSON,
    AssetSearchRequest,
    AssetSearchRequestFromJSON,
    AssetSearchRequestToJSON,
    AssetSearchResponse,
    AssetSearchResponseFromJSON,
    AssetSearchResponseToJSON,
    LastUpdateResponse,
    LastUpdateResponseFromJSON,
    LastUpdateResponseToJSON,
    MediaCenter,
    MediaCenterFromJSON,
    MediaCenterToJSON,
} from '../models';

export interface GetAssetRequest {
    mediaCenterId: string;
    assetId: number;
}

export interface GetAssetsRequest {
    mediaCenterId: string;
    assetSearchRequest: AssetSearchRequest;
}

export interface GetMediaCenterRequest {
    mediaCenterId: string;
}

/**
 * 
 */
export class DamMediaCenterApiApi extends runtime.BaseAPI {

    /**
     * Get asset with all fields
     */
    async getAssetRaw(requestParameters: GetAssetRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<Asset>> {
        if (requestParameters.mediaCenterId === null || requestParameters.mediaCenterId === undefined) {
            throw new runtime.RequiredError('mediaCenterId','Required parameter requestParameters.mediaCenterId was null or undefined when calling getAsset.');
        }

        if (requestParameters.assetId === null || requestParameters.assetId === undefined) {
            throw new runtime.RequiredError('assetId','Required parameter requestParameters.assetId was null or undefined when calling getAsset.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/asset/{mediaCenterId}/{assetId}`.replace(`{${"mediaCenterId"}}`, encodeURIComponent(String(requestParameters.mediaCenterId))).replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters.assetId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * Get asset with all fields
     */
    async getAsset(requestParameters: GetAssetRequest, initOverrides?: RequestInit): Promise<Asset> {
        const response = await this.getAssetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Asset search endpoint.
     */
    async getAssetsRaw(requestParameters: GetAssetsRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<AssetSearchResponse>> {
        if (requestParameters.mediaCenterId === null || requestParameters.mediaCenterId === undefined) {
            throw new runtime.RequiredError('mediaCenterId','Required parameter requestParameters.mediaCenterId was null or undefined when calling getAssets.');
        }

        if (requestParameters.assetSearchRequest === null || requestParameters.assetSearchRequest === undefined) {
            throw new runtime.RequiredError('assetSearchRequest','Required parameter requestParameters.assetSearchRequest was null or undefined when calling getAssets.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/assets/{mediaCenterId}`.replace(`{${"mediaCenterId"}}`, encodeURIComponent(String(requestParameters.mediaCenterId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssetSearchRequestToJSON(requestParameters.assetSearchRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetSearchResponseFromJSON(jsonValue));
    }

    /**
     * Asset search endpoint.
     */
    async getAssets(requestParameters: GetAssetsRequest, initOverrides?: RequestInit): Promise<AssetSearchResponse> {
        const response = await this.getAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get media center config.
     */
    async getMediaCenterRaw(requestParameters: GetMediaCenterRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<MediaCenter>> {
        if (requestParameters.mediaCenterId === null || requestParameters.mediaCenterId === undefined) {
            throw new runtime.RequiredError('mediaCenterId','Required parameter requestParameters.mediaCenterId was null or undefined when calling getMediaCenter.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/media-center/{mediaCenterId}`.replace(`{${"mediaCenterId"}}`, encodeURIComponent(String(requestParameters.mediaCenterId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MediaCenterFromJSON(jsonValue));
    }

    /**
     * Get media center config.
     */
    async getMediaCenter(requestParameters: GetMediaCenterRequest, initOverrides?: RequestInit): Promise<MediaCenter> {
        const response = await this.getMediaCenterRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get media center config.
     */
    async getMediaCenterUpdateRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<LastUpdateResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/media-center/lastUpdate`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LastUpdateResponseFromJSON(jsonValue));
    }

    /**
     * Get media center config.
     */
    async getMediaCenterUpdate(initOverrides?: RequestInit): Promise<LastUpdateResponse> {
        const response = await this.getMediaCenterUpdateRaw(initOverrides);
        return await response.value();
    }

    /**
     * Backend ping endpoint
     */
    async getPingRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/ping`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Backend ping endpoint
     */
    async getPing(initOverrides?: RequestInit): Promise<string> {
        const response = await this.getPingRaw(initOverrides);
        return await response.value();
    }

}
